import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUndoUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-undo-up, back, top "><path d="M7 5L3 9L7 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4 9H21.25V18.25H11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowUndoUp;
